import { isNil } from 'lodash';

const checkIfProducthasLoadCharges = (hasMinimumLoadCharge, minimumLoadChargeData) => {
  if (!hasMinimumLoadCharge) return true;
  if (!minimumLoadChargeData?.charges?.length) return false;
  return !minimumLoadChargeData?.charges?.every(c => isNil(c?.loadSize) && isNil(c?.charge));
};

export default checkIfProducthasLoadCharges;
